export const dashboardEntry = {
  key: 'executive',
  title: 'Executive',
  description: 'Are we getting safer? Risk trend, top risks, compliance and phishing resilience in one view.',
  route: '/dashboards/executive',
  icon: 'gauge',
  apps: ['aware', 'xes', 'posture', 'surface', 'insider'],
  adminOnly: true,
} as const;
